const reportsMap = [
  {
    link: "action-items",
    ident: "reports-action-items", // "-study" | "-request"
    hasEntityTypes: true,
  },
  {
    link: "reports/activity",
    ident: "reports-activity",
  },
  {
    link: "reports/activity-step",
    ident: "reports-activity-step",
  },
  {
    link: "reports/assessment",
    ident: "reports-assessment",
  },
  {
    link: "reports/assessment-change",
    ident: "reports-assessment-change",
  },
  {
    link: "reports/bottleneck",
    ident: "reports-bottleneck",
  },
  {
    link: "reports/comment",
    ident: "reports-comment", // "-study" | "-request"
    hasEntityTypes: true,
  },
  {
    link: "reports/data-change",
    ident: "reports-data-change",
  },
  {
    link: "reports/data-import",
    ident: "reports-data-import", // "-study" | "-request"
    hasEntityTypes: true,
  },
  {
    link: "reports/maintenance",
    ident: "reports-maintenance",
  },
  {
    link: "reports/new-request",
    ident: "reports-new-request",
  },
  {
    link: "reports/new-study",
    ident: "reports-new-study",
  },
  {
    link: "reports/request",
    ident: "reports-request", // "-<requestTypeId>"
    hasRequestTypes: true,
  },
  {
    link: "reports/study-site",
    ident: "reports-study-site",
  },
  {
    link: "reports/submissions",
    ident: "reports-submissions",
  },
]

/**
 * Used for preset and subscription APIs
 * @param {string} reportLink from all-reports api
 * @param {string} apiConfig.requestTypeId needed for individual Request Report request type views
 * @returns reports identifier (string)
 */
const getGridPresetIdent = (reportLink, apiConfig) => {
  const getReport = (link) => reportsMap.find((item) => item.link === link)

  const getIdentFromMap = (link) => {
    return reportsMap.find((item) => item.link === link)?.ident || link
  }

  // Request Report
  // TODO: send the request unique ID, eg, "34", in the the report_type instead of sending the request ID, eg "EMA Policy...", on that property. That way the requestTypeId does not have to be sent.
  if (apiConfig?.requestTypeId && getReport(reportLink)?.hasRequestTypes) {
    // eg, "reports-request-34"
    return `${getIdentFromMap(reportLink)}-${apiConfig.requestTypeId}`
  }

  // reports with "study" and "request" versions
  if (apiConfig?.report_type && getReport(reportLink)?.hasEntityTypes) {
    // ef, "action-items-study" || "action-items-request"
    return `${getIdentFromMap(reportLink)}-${apiConfig?.report_type}`
  }

  return getIdentFromMap(reportLink)
}

export {
  getGridPresetIdent,
}